/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Tool usage aggregation target kind
 */
export const ToolUsageTargetToolBreakdownRowTargetKind = {
  Server: "server",
  LocalTools: "local_tools",
  Skill: "skill",
} as const;
/**
 * Tool usage aggregation target kind
 */
export type ToolUsageTargetToolBreakdownRowTargetKind = ClosedEnum<
  typeof ToolUsageTargetToolBreakdownRowTargetKind
>;

/**
 * Tool usage target type
 */
export const ToolUsageTargetToolBreakdownRowTargetType = {
  HostedMcpServer: "hosted_mcp_server",
  TunneledMcpServer: "tunneled_mcp_server",
  MetaMcpServer: "meta_mcp_server",
  ShadowMcpServer: "shadow_mcp_server",
  LocalTool: "local_tool",
  Skill: "skill",
} as const;
/**
 * Tool usage target type
 */
export type ToolUsageTargetToolBreakdownRowTargetType = ClosedEnum<
  typeof ToolUsageTargetToolBreakdownRowTargetType
>;

/**
 * Aggregated tool usage metrics for one target and tool
 */
export type ToolUsageTargetToolBreakdownRow = {
  /**
   * Total number of tool usage events for the target and tool
   */
  eventCount: number;
  /**
   * Number of failed tool usage events for the target and tool
   */
  failureCount: number;
  /**
   * Fraction of completed tool usage events for the target and tool that failed
   */
  failureRate: number;
  /**
   * Number of successful tool usage events for the target and tool
   */
  successCount: number;
  /**
   * Stable target identifier used by filters and chart grouping
   */
  targetId: string;
  /**
   * Tool usage aggregation target kind
   */
  targetKind: ToolUsageTargetToolBreakdownRowTargetKind;
  /**
   * User-facing label for the target
   */
  targetLabel: string;
  /**
   * Tool usage target type
   */
  targetType: ToolUsageTargetToolBreakdownRowTargetType;
  /**
   * Observed tool name
   */
  toolName: string;
};

/** @internal */
export const ToolUsageTargetToolBreakdownRowTargetKind$inboundSchema:
  z.ZodMiniEnum<typeof ToolUsageTargetToolBreakdownRowTargetKind> = z.enum(
    ToolUsageTargetToolBreakdownRowTargetKind,
  );

/** @internal */
export const ToolUsageTargetToolBreakdownRowTargetType$inboundSchema:
  z.ZodMiniEnum<typeof ToolUsageTargetToolBreakdownRowTargetType> = z.enum(
    ToolUsageTargetToolBreakdownRowTargetType,
  );

/** @internal */
export const ToolUsageTargetToolBreakdownRow$inboundSchema: z.ZodMiniType<
  ToolUsageTargetToolBreakdownRow,
  unknown
> = z.pipe(
  z.object({
    event_count: z.int(),
    failure_count: z.int(),
    failure_rate: z.number(),
    success_count: z.int(),
    target_id: z.string(),
    target_kind: ToolUsageTargetToolBreakdownRowTargetKind$inboundSchema,
    target_label: z.string(),
    target_type: ToolUsageTargetToolBreakdownRowTargetType$inboundSchema,
    tool_name: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "event_count": "eventCount",
      "failure_count": "failureCount",
      "failure_rate": "failureRate",
      "success_count": "successCount",
      "target_id": "targetId",
      "target_kind": "targetKind",
      "target_label": "targetLabel",
      "target_type": "targetType",
      "tool_name": "toolName",
    });
  }),
);

export function toolUsageTargetToolBreakdownRowFromJSON(
  jsonString: string,
): SafeParseResult<ToolUsageTargetToolBreakdownRow, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ToolUsageTargetToolBreakdownRow$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ToolUsageTargetToolBreakdownRow' from JSON`,
  );
}
